define(["jquery", "jqueryDatepicker"], function ($, datepicker) {
    var datepickerwrapper = {
        init: function () {
            $("input.datepicker").datetimepicker({
                lang: "se",
                dayOfWeekStart: 1,
                format: "Y-m-d",
                timepicker: false,
                validateOnBlur: false,
                allowBlank: true,
                scrollMonth: false,
                scrollInput: false
            });
        }
    };
    return datepickerwrapper;
});